// Google Analytics Utility
// Measurement ID: G-NDQHQ4QTZZ

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

const GA_MEASUREMENT_ID = 'G-NDQHQ4QTZZ';

// Track page views (for SPA navigation)
export const trackPageView = (url: string, title?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user sign up
export const trackSignUp = (method: string = 'email') => {
  trackEvent('sign_up', 'engagement', method);
};

// Track user login
export const trackLogin = (method: string = 'email') => {
  trackEvent('login', 'engagement', method);
};

// Track subscription purchase
export const trackSubscription = (plan: string, value: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      currency: 'USD',
      value: value,
      items: [
        {
          item_name: `${plan} Plan`,
          item_category: 'subscription',
          price: value,
          quantity: 1,
        },
      ],
    });
  }
};

// Track credit purchase
export const trackCreditPurchase = (credits: number, price: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      currency: 'USD',
      value: price,
      items: [
        {
          item_name: `${credits} Credits`,
          item_category: 'credits',
          price: price,
          quantity: 1,
        },
      ],
    });
  }
};

// Track AI employee chat started
export const trackChatStarted = (employeeId: string, employeeName: string) => {
  trackEvent('chat_started', 'ai_employee', `${employeeName} (${employeeId})`);
};

// Track message sent
export const trackMessageSent = (employeeId: string) => {
  trackEvent('message_sent', 'chat', employeeId);
};

// Track document uploaded to Brain AI
export const trackDocumentUpload = (documentType: string) => {
  trackEvent('document_upload', 'brain_ai', documentType);
};

// Track integration connected
export const trackIntegrationConnected = (provider: string) => {
  trackEvent('integration_connected', 'integrations', provider);
};

// Track task created
export const trackTaskCreated = (employeeId: string) => {
  trackEvent('task_created', 'tasks', employeeId);
};

// Track feature usage
export const trackFeatureUsage = (featureName: string) => {
  trackEvent('feature_used', 'features', featureName);
};

// Track button clicks
export const trackButtonClick = (buttonName: string, location: string) => {
  trackEvent('button_click', location, buttonName);
};

// Track search
export const trackSearch = (searchTerm: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'search', {
      search_term: searchTerm,
    });
  }
};

// Track errors
export const trackError = (errorMessage: string, errorLocation: string) => {
  trackEvent('error', errorLocation, errorMessage);
};

export default {
  trackPageView,
  trackEvent,
  trackSignUp,
  trackLogin,
  trackSubscription,
  trackCreditPurchase,
  trackChatStarted,
  trackMessageSent,
  trackDocumentUpload,
  trackIntegrationConnected,
  trackTaskCreated,
  trackFeatureUsage,
  trackButtonClick,
  trackSearch,
  trackError,
};
